import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from "@sentry/react";
import App from './App.tsx';
import './index.css';

// Initialize Sentry for error tracking
Sentry.init({
  dsn: "https://d67af7ba8c1ed81fca1ca84f763f5a62@o4509465242959872.ingest.de.sentry.io/4509582864613456",
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,

  enabled: true, // or `true` for all environments
  sendDefaultPii: true, // optional, for richer error data
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);